import React, { useCallback, useEffect, useState } from 'react'
import InputTextField from '../../../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { ButtonBack, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import TableCustom from '../../../../../components/table/tableCustom';
import { unsetLoading } from '../../../../../store/loading/loading.slice';
import TableRowCommon from '../../../../../components/table/TableRowCommon';
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom';
import { alertActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import { dateTimeToView } from '../../../../../utils/date.utils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { OnlineCourseApi } from '../../../../../api/cms-online-course/online_course.api';
import FilterSelect from '../../../../../components/select/filterSelect';
import { MenuItem } from '@mui/material';
import ModalCustom from '../../../../../components/modal/ModalCustom';
const defaultState = {
    id_online_course_study_topics: undefined,
    online_course_terminology: '',
    online_course_terminology_desc: '',
}
export default function Terminology({ view }: any) {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [open, setOpen] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [listLesson, setListLesson] = useState<any[]>([]);
    const [listLessonTopic, setListLessonTopic] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: 'ลำดับ'
        },
        {
            id: "leave_type_name",
            width: '180px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("คำศัพท์"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '250px',
            sortable: false,
            align: "start",
            label: t("คำอธิบาย"),
        },
        // {
        //     id: "user_updated",
        //     disablePadding: false,
        //     align: "center",
        //     width: '200px',
        //     label: t("ภายใต้หัวข้อการเรียน"),
        // },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '120px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_online_course_terminology,
            online_course_terminology,
            online_course_terminology_desc,
            online_course_study_topics_name,
            modifier_name,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_online_course_terminology,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: online_course_terminology,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: (
                        online_course_terminology_desc || '-'
                    ),
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: (
                //         online_course_study_topics_name || '-'
                //     ),
                // },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit={!view}
                            enableDelete={!view}
                            onViewClick={() => {
                                setOpen(true)
                                setType('VIEW')
                                setForm(objData)
                            }}

                            onEditClick={() => {
                                setOpen(true)
                                setType('EDIT')
                                setForm(objData)
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_online_course_terminology)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        // dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await OnlineCourseApi.listTerminology(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,search]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const listLessonData = async () => {

        try {
            const res = await OnlineCourseApi.listLesson(id);
            const data = res.data
            if (data?.status < 300) {
                setListLesson(data?.data);

            } else {
            }
        } catch (error) {
        }
    }
    const listLessonTopicData = async (id_online_course_lesson: any) => {

        try {
            const res = await OnlineCourseApi.listLessonTopic(id, id_online_course_lesson);
            const data = res.data
            if (data?.status < 300) {
                setListLessonTopic(data?.data);

            } else {
            }
        } catch (error) {
        }
    }
    useEffect(() => {
        listLessonData()
    }, [])
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }
    const handleCreate = async () => {
        const body = {
            id_online_course_study_topics: form?.id_online_course_study_topics,
            online_course_terminology: form?.online_course_terminology,
            online_course_terminology_desc: form?.online_course_terminology_desc,
        };
        if (type === 'EDIT') {
            await OnlineCourseApi.patchTerminology(body, id, form.id_online_course_terminology).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('บันทึกคำศัพท์ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await OnlineCourseApi.postTerminology(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มคำศัพท์ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }

    const handleDelete = async (id_terminology: any) => {
        await OnlineCourseApi.deleteTerminology(id, id_terminology).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })



    }
    return (
        <div>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    {!view && <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.OnlineCourseManagementCreate);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("เพิ่มคำศัพท์")}
                    />}
                </article>
            </div>
            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t('เพิ่มคำศัพท์') : t('ข้อมูลคำศัพท์')} subTitle={t('กรุณาระบุรายละเอียด')} open={open} component={
                <div className='flex flex-col gap-4'>


                    <div>
                        <InputTextField
                            heading={t("คำศัพท์")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, online_course_terminology: e.target.value })
                            }}
                            value={form.online_course_terminology || ''}
                            required
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t("คำอธิบาย")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, online_course_terminology_desc: e.target.value })
                            }}
                            value={form.online_course_terminology_desc || ''}
                            multiline
                            minRow={6}
                            inputHeight={'auto'}
                        />
                    </div>
                    {/* <div>
                        <FilterSelect
                            value={form?.id_online_course_lesson || ""}
                            heading={t('อยู่ภายใต้บทเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLesson.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_lesson} key={index + 1}>
                                    {item.online_course_lesson_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                listLessonTopicData(e.target.value)
                                setForm({ ...form, id_online_course_lesson: e.target.value })
                            }}
                            disabled={false}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            value={form?.id_online_course_study_topics || ""}
                            heading={t('ภายใต้หัวข้อการเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLessonTopic.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_study_topics} key={index + 1}>
                                    {item.online_course_study_topics_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_online_course_study_topics: e.target.value })
                            }}
                            disabled={!form?.id_online_course_lesson}
                        />
                    </div> */}

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
